// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"746":"4dd74e2b047cde50","972":"6886c6715840fb42"}[chunkId] + ".css";
};